import { FeatureAppConfig } from "../../types/service-configs"
import { ModelOverviewIntegratorOptions } from "../create-options-from-query-params"

const graphQLServerUrl: string = 'http://localhost:8080/graphql';

// const carouselId: string = 'MDhkMzlhYzA2NTlkZGNjNTll.js';
const contentHubId: string = 'OWU0MjYyN2QwNGNhYWVkNjg4.js';
// const mosaicId: string = 'ZmRhNzcxYjAzZjk5MzU2MDMw.js';

export const createStoryStreamAppConfig = ({ mode, faServicesUrl }: ModelOverviewIntegratorOptions): FeatureAppConfig & any => {
  return {
    faServicesUrl,
    graphQLServerUrl,
    hasContentConfig: true,
    mode,
    storyStreamAppId: contentHubId,
    storyStreamBaseUrl: 'https://apps.storystream.ai/app/js/',
  }
}
